import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { AppKyc } from "../types";

export const useAppKycs = () => {
  const [appKycs, setAppKycs] = useState<AppKyc[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAppKycs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getAppKycs();
      setAppKycs(data);
    } catch (err: unknown) {
      console.error(err);
      setError(err instanceof Error ? err.message : "Failed to fetch App KYC records");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAppKycs();
  }, [fetchAppKycs]);

  return { appKycs, loading, error, refresh: fetchAppKycs };
};
